module.exports = __webpack_public_path__ + "img/main-collage.248e7ce4.jpg";